import IconPlay from '@anm/components/IconPlay';
import Loader from '@anm/components/Loader';
import PlayerWrapper from '@anm/components/PlayerWrapper';
import Image from '@anm/components/image/Image';
import Modal from '@anm/components/modals/Modal';
import { getPlayerThumbnail } from '@anm/helpers/waveVideo';
import useSwitchState from '@anm/hooks/useSwitchState';
import useVideoModalDimension from '@anm/hooks/useVideoModalDimension';
import { Manifest } from '@anm/hosting-player';
import { FC } from 'react';

import { SlideProps } from '.';
import {
  CloseButton,
  CustomerDetails,
  ImageContainer,
  InfoWrapper,
  LoaderContainer,
  PlayerContainer,
  SlideWrapper,
  SocialMediaWrapper
} from './Wrapper';
import { usePlayerReInit } from './hooks';

type VideoSlideProps = SlideProps & {
  manifest: Manifest;
};

const VideoSlide: FC<VideoSlideProps> = ({ icons, videoId, manifest, position, name: customerName }) => {
  const [isModalOpen, openModal, closeModal] = useSwitchState();
  const [isVideoInited, setIsVideoInited] = useSwitchState();
  const [modalWidth, playerContainerRef] = useVideoModalDimension(isVideoInited);

  usePlayerReInit({ isModalOpen, playerContainerRef });

  if (!manifest) {
    return (
      <LoaderContainer>
        <Loader size="medium" color="blue" />
      </LoaderContainer>
    );
  }

  const { name: alt, thumbnail } = getPlayerThumbnail(manifest);

  return (
    <>
      {isModalOpen && (
        <Modal onModalClose={closeModal}>
          <CloseButton onClick={closeModal} />

          <PlayerContainer ref={playerContainerRef} width={modalWidth}>
            <PlayerWrapper
              previewSrc={thumbnail}
              onPlayerInit={setIsVideoInited}
              playerWrapperRef={playerContainerRef}
              {...{ videoId, manifest }}
            />
          </PlayerContainer>
        </Modal>
      )}
      <SlideWrapper>
        <ImageContainer>
          <IconPlay size="80x80" playIconUrl="images/icons/btn-play-pink.svg" onClick={openModal} />
          <Image src={thumbnail} alt={alt} />
        </ImageContainer>
        <InfoWrapper>
          <CustomerDetails level={3} title={customerName} description={position} />
          <SocialMediaWrapper>
            {icons.map(({ name, href }) => (
              <a key={href + name} {...{ href }} target="_blank">
                <Image alt={name} src={`images/icons/social/${name}_v1.svg`} />
              </a>
            ))}
          </SocialMediaWrapper>
        </InfoWrapper>
      </SlideWrapper>
    </>
  );
};

export default VideoSlide;
